import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import store from './store';

import 'vue-awesome/icons'
import axios from 'axios'
import IaApp from './components/ia/IaApp.vue';
import RfidLogin from './components/ia/RfidLogin.vue';

var Icon = require('vue-awesome/components/Icon.vue');
Vue.component('icon', Icon);

axios.defaults.headers.common['X-CSRFToken'] = getCookie('crmcsrftoken');
Vue.prototype.$http = axios;

Raven.config(window.raven.dsn, {
    environment: 'PROD', tags: {app: window.raven.app},
}).addPlugin(RavenVue, Vue).install();

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

if (document.getElementById('iaApp')) {
    new Vue({
        el: '#iaApp', store, components: {
            'app': IaApp, 'rfid-login': RfidLogin,
        }
    });
}

// get styles so webpack can include them in bundle
require('../css/style-main.scss')



// WEBPACK FOOTER //
// ./app/main.js